module.exports = __webpack_public_path__ + "img/logo.d8d1b0f0.png";